import { render, staticRenderFns } from "./PublisherDashboardPluginCard.vue?vue&type=template&id=22ab9dd0&"
import script from "./PublisherDashboardPluginCard.vue?vue&type=script&lang=js&"
export * from "./PublisherDashboardPluginCard.vue?vue&type=script&lang=js&"
import style0 from "./PublisherDashboardPluginCard.vue?vue&type=style&index=0&id=22ab9dd0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports